// extracted by mini-css-extract-plugin
module.exports = {"button":"HeroMenu_button__2jgYi","Paper":"HeroMenu_Paper__2C_9v"};